import { defineComponent as z, computed as w, createElementBlock as v, openBlock as n, normalizeClass as b, unref as l, createElementVNode as p, createCommentVNode as h, normalizeStyle as j, createVNode as T, withCtx as m, createBlock as f, renderSlot as I, ref as $, readonly as G, Fragment as L, renderList as V, createSlots as x, createTextVNode as k, toDisplayString as C, TransitionGroup as X } from "vue";
import { IconBase as B, IconSize as F, Info as q, Error as O, CheckRounded as J, Times as K } from "@myparcel-frontend/ui";
import { useI18n as P } from "vue-i18n";
const g = {
  Info: "info",
  Success: "success",
  Warning: "warning",
  Error: "alert"
}, S = {
  Full: "full",
  Half: "half"
}, A = {
  Toaster: "toaster"
}, Q = { key: 0 }, Y = { class: "content flex flex-col grow" }, Z = { class: "empty:hidden font-bold" }, ee = { class: "body" }, E = /* @__PURE__ */ z({
  __name: "Toast",
  props: {
    id: {},
    variant: {},
    timeout: { default: 6e3 },
    size: { default: S.Full },
    canClose: { type: Boolean },
    withShadow: { type: Boolean }
  },
  emits: ["remove"],
  setup(d, { emit: c }) {
    const o = d, i = c;
    o.timeout && setTimeout(() => {
      i("remove", o.id);
    }, o.timeout);
    const a = w(() => o.variant === g.Info), t = w(() => o.variant === g.Error), r = w(() => o.variant === g.Warning), e = w(() => o.variant === g.Success);
    return (u, s) => (n(), v("div", {
      class: b(["border border-gray-400 flex items-center mb-4 md:text-base overflow-hidden p-4 pointer-events-auto relative rounded-lg transform-gpu", {
        "drop-shadow-md": u.withShadow,
        "pb-5!": !!u.timeout,
        "md:min-w-[400px] md:max-w-3xl md:min-h-[56px]": u.size === l(S).Half,
        "bg-green-100": e.value,
        "bg-blue-100": a.value,
        "bg-yellow-100": r.value,
        "bg-red-100": t.value
      }]),
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
      "data-test": "toast"
    }, [
      u.timeout ? (n(), v("div", Q, [
        p("div", {
          class: b(["absolute bottom-0 h-1 left-0 origin-left w-full animate-shrink", {
            "bg-blue": a.value,
            "bg-green": e.value,
            "bg-yellow": r.value,
            "bg-red": t.value
          }]),
          style: j({
            "animation-duration": u.timeout + "ms"
          })
        }, null, 6),
        p("div", {
          class: b(["absolute bottom-0 h-1 left-0 opacity-20 w-full", {
            "bg-blue": a.value,
            "bg-green": e.value,
            "bg-yellow": r.value,
            "bg-red": t.value
          }])
        }, null, 2)
      ])) : (n(), v("div", {
        key: 1,
        class: b(["absolute h-full left-0 top-0 w-1", {
          "bg-blue": a.value,
          "bg-green": e.value,
          "bg-yellow": r.value,
          "bg-red": t.value
        }])
      }, null, 2)),
      p("div", {
        class: b(["flex-none pr-4", {
          "text-blue": a.value,
          "text-green": e.value,
          "text-yellow": r.value,
          "text-red": t.value
        }])
      }, [
        T(l(B), {
          size: l(F).Normal
        }, {
          default: m(() => [
            a.value ? (n(), f(l(q), { key: 0 })) : h("", !0),
            t.value ? (n(), f(l(O), { key: 1 })) : h("", !0),
            r.value ? (n(), f(l(O), { key: 2 })) : h("", !0),
            e.value ? (n(), f(l(J), { key: 3 })) : h("", !0)
          ]),
          _: 1
        }, 8, ["size"])
      ], 2),
      p("div", Y, [
        p("div", Z, [
          I(u.$slots, "title")
        ]),
        p("div", ee, [
          I(u.$slots, "default")
        ])
      ]),
      u.canClose ? (n(), v("button", {
        key: 2,
        type: "button",
        class: "button close flex-none pl-4",
        onClick: s[0] || (s[0] = (M) => u.$emit("remove", u.id))
      }, [
        T(l(B), {
          size: l(F).Normal,
          class: "cursor-pointer"
        }, {
          default: m(() => [
            T(l(K))
          ]),
          _: 1
        }, 8, ["size"])
      ])) : h("", !0)
    ], 2));
  }
}), _ = $([]), R = $(0), te = 6e3, oe = 3e4;
function U() {
  const d = ({
    id: i,
    variant: a = g.Info,
    canClose: t,
    withShadow: r,
    body: e,
    title: u,
    timeout: s = te,
    location: M = A.Toaster
  }) => {
    let y = i;
    y || (R.value++, y = R.value.toString());
    const W = window.matchMedia("(prefers-reduced-motion: reduce)").matches, D = Math.min(s, oe), N = W ? 0 : D;
    _.value.unshift({
      id: y,
      body: e,
      variant: a,
      title: u,
      timeout: N,
      location: M,
      canClose: N ? t : !0,
      withShadow: r
    }), N && setTimeout(() => {
      c(y);
    }, N);
  }, c = (i) => {
    _.value = _.value.filter((a) => a.id !== i);
  }, o = () => {
    _.value = [];
  };
  return {
    notifications: G(_),
    addNotification: d,
    removeNotification: c,
    clearNotifications: o
  };
}
const ae = ["data-test"], ne = /* @__PURE__ */ z({
  __name: "LocationContainer",
  props: {
    location: {}
  },
  setup(d) {
    const { notifications: c, removeNotification: o } = U(), i = d, a = w(() => c.value.filter((t) => t.location === i.location));
    return (t, r) => (n(), v("div", {
      "data-test": `notifications ${t.location}`
    }, [
      (n(!0), v(L, null, V(a.value, (e) => (n(), f(E, {
        id: e.id ?? "",
        key: e.id,
        size: l(S).Full,
        timeout: e.timeout,
        variant: e.variant,
        "can-close": e.canClose,
        "with-shadow": e.withShadow,
        class: "flex-none",
        onRemove: l(o)
      }, x({
        default: m(() => [
          k(" " + C(e.body), 1)
        ]),
        _: 2
      }, [
        e.title ? {
          name: "title",
          fn: m(() => [
            k(C(e.title), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "size", "timeout", "variant", "can-close", "with-shadow", "onRemove"]))), 128))
    ], 8, ae));
  }
}), H = (d, c) => {
  const o = d.__vccOpts || d;
  for (const [i, a] of c)
    o[i] = a;
  return o;
}, ce = /* @__PURE__ */ H(ne, [["__scopeId", "data-v-490b4271"]]), de = /* @__PURE__ */ z({
  __name: "Notification",
  props: {
    id: {},
    variant: {},
    canClose: { type: Boolean },
    withShadow: { type: Boolean },
    timeout: { default: 0 }
  },
  emits: ["remove"],
  setup(d, { emit: c }) {
    const o = c, i = $(!0), a = () => {
      i.value = !1, o("remove");
    };
    return (t, r) => i.value ? (n(), f(E, {
      key: 0,
      id: t.id,
      class: "relative",
      variant: t.variant,
      "can-close": t.canClose,
      "with-shadow": t.withShadow,
      timeout: t.timeout,
      "data-test": "notification",
      onRemove: a
    }, {
      title: m(() => [
        I(t.$slots, "title")
      ]),
      default: m(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "variant", "can-close", "with-shadow", "timeout"])) : h("", !0);
  }
}), ie = { id: "notification__container" }, se = /* @__PURE__ */ z({
  __name: "NotificationContainer",
  setup(d) {
    const { t: c, te: o } = P(), { notifications: i, removeNotification: a } = U(), t = w(() => i.value.filter(
      (e) => e.location === A.Toaster
    )), r = (e) => o(e) ? c(e) : e;
    return (e, u) => (n(), v("div", ie, [
      T(X, { name: "list" }, {
        default: m(() => [
          (n(!0), v(L, null, V(t.value, (s) => (n(), f(E, {
            id: s.id ?? "",
            key: s.id,
            size: l(S).Half,
            timeout: s.timeout,
            variant: s.variant,
            "can-close": s.canClose,
            "with-shadow": s.withShadow,
            class: "flex-none",
            onRemove: l(a)
          }, x({
            default: m(() => [
              k(" " + C(r(s.body)), 1)
            ]),
            _: 2
          }, [
            s.title ? {
              name: "title",
              fn: m(() => [
                k(C(r(s.title)), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["id", "size", "timeout", "variant", "can-close", "with-shadow", "onRemove"]))), 128))
        ]),
        _: 1
      })
    ]));
  }
}), me = /* @__PURE__ */ H(se, [["__scopeId", "data-v-ce371d92"]]);
export {
  ce as LocationContainer,
  de as Notification,
  me as NotificationContainer,
  A as NotificationLocation,
  S as NotificationSize,
  g as NotificationVariant,
  U as useNotification
};
